export default "__VITE_ASSET__CVCr3Ta9__"